























import { Component, Vue } from 'vue-property-decorator';

import { Header, Footer } from '@/components';
import { Layout } from '@/components/core';

@Component({
  components: { Layout, Header, Footer },
})
export default class App extends Vue {
  private blockName: string = 'app';

  private pass() {
    // Do nothing
  }
}
